import clsx from 'clsx';
import { FC } from 'react';
import { Image } from 'atoms/Image/Image';
import { Span } from 'atoms/Typography';
import { useSiteConfig } from 'modules/shop/siteConfig/hooks';
import styles from './styles.module.css';

interface CopyrightProps {
  simple?: boolean;
}

export const Copyright: FC<CopyrightProps> = ({ simple }) => {
  const { footer } = useSiteConfig();
  const copyright = footer?.copyright?.[0];

  return !copyright ? null : (
    <div
      className={clsx(styles.root, {
        [styles.simple]: simple,
      })}
    >
      <Image
        src={copyright.image?.filename}
        className={styles.image}
        alt={copyright.image?.alt}
      />
      <Span className={styles.text}>{copyright.text}</Span>
    </div>
  );
};
